import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueObserveVisibility from 'vue-observe-visibility'

import { createRouter } from './router'
import { createStore } from './store'
import { sync } from 'vuex-router-sync'

Vue.use(VueAxios, axios)
Vue.use(VueObserveVisibility)
Vue.use(Antd)

Vue.config.productionTip = false

async function createApp () {
  const router = createRouter({
    STORAGE_TOKEN_ID: process.env.VUE_APP_STORAGE_TOKEN_ID
  })
  const store = createStore({
    APPLICATION_VERSION: process.env.VUE_APP_APPLICATION_VERSION,
    STORAGE_TOKEN_ID: process.env.VUE_APP_STORAGE_TOKEN_ID,
    STORAGE_PERSIST_ID: process.env.VUE_APP_STORAGE_PERSIST_ID,
    CAMPUS_API_HOST: process.env.VUE_APP_CAMPUS_API_HOST,
    CAMPUS_API_KEY: process.env.VUE_APP_CAMPUS_API_KEY
  }, axios)

  sync(store, router)

  await store.dispatch('init')

  const app = new Vue({
    router,
    store,
    components: { App },
    template: '<App/>',
    ...App
  })

  return {
    app,
    router,
    store
  }
}

// now create the app
createApp({
  ssr: false
}).then(({ app, store }) => {
  // Restore the Vuex store state
  // if send by the server
  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
  }

  // Mount the app into the page
  app.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js